import React from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { SquaresFour, HardDrives, PlusCircle, Gear, SignOut, FolderOpen, ArrowLeft, Cube, Cloud, Link as LinkIcon, WindowsLogo, ShieldWarning, FileZip, Martini, Globe, ChartLineUp, CloudArrowUp, Hammer, PaperPlaneTilt, ArrowsClockwise, Desktop, Users, Browser, TelegramLogo, Robot } from '@phosphor-icons/react';
import Logo from './Logo';

import { useAuth } from './AuthContext';
const Sidebar = () => {
  const { logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  
  const isHeroku = location.pathname.startsWith('/heroku');
  const isAzure = location.pathname.startsWith('/azure');
  const isNamecheap = location.pathname.startsWith('/namecheap');
  const isCocktail = location.pathname.startsWith('/cocktail');
  const isAnalytics = location.pathname.startsWith('/analytics');
  const isDO = location.pathname.startsWith('/do');
  const isForge = location.pathname.startsWith('/forge');
  const isRDP = location.pathname.startsWith('/rdp');
  const isVultr = location.pathname.startsWith('/vultr');
  const isWordpress = location.pathname.startsWith('/wordpress');
  const isDcbot = location.pathname.startsWith('/dcbot');
  const isAmplify = location.pathname.startsWith('/amplify');

  const doLinks = [
    { to: "/do", icon: <SquaresFour size={20} />, label: "Dashboard", exact: true },
    { to: "/do/saved-sites", icon: <FolderOpen size={20} />, label: "Saved Sites" },
    { to: "/do/deployments/new", icon: <PlusCircle size={20} />, label: "New Deployment" },
    { to: "/do/proxy", icon: <PaperPlaneTilt size={20} />, label: "MTProto Proxy" },
    { to: "/do/urls", icon: <LinkIcon size={20} />, label: "Manage URLs" },
    { to: "/do/bulk-override", icon: <CloudArrowUp size={20} />, label: "Bulk Override" },
    { to: "/do/wipe", icon: <ShieldWarning size={20} className="text-red-500" />, label: <span className="text-red-500 font-bold">Master Wipe</span> },
    { to: "/do/accounts", icon: <HardDrives size={20} />, label: "DO Accounts" },
    { to: "/do/settings", icon: <Gear size={20} />, label: "Settings" },
  ];

  const herokuLinks = [
    { to: "/heroku", icon: <SquaresFour size={20} />, label: "Dashboard", exact: true },
    { to: "/heroku/templates", icon: <FolderOpen size={20} />, label: "Git Templates" },
    { to: "/heroku/deployments/new", icon: <PlusCircle size={20} />, label: "New Deployment" },
    { to: "/heroku/urls", icon: <LinkIcon size={20} />, label: "Manage URLs" },
    { to: "/heroku/existing-manager", icon: <ArrowsClockwise size={20} />, label: "Existing URL Manager" },
    { to: "/heroku/wipe", icon: <ShieldWarning size={20} className="text-red-500" />, label: <span className="text-red-500 font-bold">Master Wipe</span> },
    { to: "/heroku/accounts", icon: <HardDrives size={20} />, label: "Heroku Accounts" },
  ];

  const azureLinks = [
    { to: "/azure", icon: <SquaresFour size={20} />, label: "Dashboard", exact: true },
    { to: "/azure/saved-sites", icon: <FolderOpen size={20} />, label: "Saved Sites" },
    { to: "/azure/deployments/new", icon: <PlusCircle size={20} />, label: "Static Deployer" },
    { to: "/azure/deployments/php/new", icon: <FileZip size={20} />, label: "PHP Deployer" },
    { to: "/azure/uploader", icon: <CloudArrowUp size={20} />, label: "File Uploader" },
    { to: "/azure/urls", icon: <LinkIcon size={20} />, label: "Manage URLs" },
    { to: "/azure/wipe", icon: <ShieldWarning size={20} className="text-red-500" />, label: <span className="text-red-500 font-bold">Master Wipe</span> },
    { to: "/azure/tester", icon: <ShieldWarning size={20} />, label: "Account Tester" },
    { to: "/azure/accounts", icon: <HardDrives size={20} />, label: "Azure Accounts" },
  ];

  const cocktailLinks = [
    { to: "/cocktail", icon: <SquaresFour size={20} />, label: "Dashboard", exact: true },
    { to: "/cocktail/deployments/new", icon: <Martini size={20} />, label: "New Cocktail" },
    { to: "/cocktail/urls", icon: <LinkIcon size={20} />, label: "Manage URLs" },
  ];

  const namecheapLinks = [
    { to: "/namecheap", icon: <SquaresFour size={20} />, label: "Dashboard", exact: true },
    { to: "/namecheap/deployments/new", icon: <PlusCircle size={20} />, label: "Namecheap+Heroku deployer" },
    { to: "/namecheap/azure/new", icon: <WindowsLogo size={20} />, label: "Azure Threesome" },
    { to: "/namecheap/accounts", icon: <HardDrives size={20} />, label: "Namecheap Accounts" },
    { to: "/namecheap/hostinger-accounts", icon: <HardDrives size={20} />, label: "Hostinger Accounts" },
  ];

  const forgeLinks = [
    { to: "/forge", icon: <SquaresFour size={20} />, label: "Dashboard", exact: true },
    { to: "/forge/deployments/new", icon: <PlusCircle size={20} />, label: "New Deployment" },
    { to: "/forge/urls", icon: <LinkIcon size={20} />, label: "Manage URLs" },
    { to: "/forge/templates", icon: <FolderOpen size={20} />, label: "Git / Zip Templates" },
    { to: "/forge/wipe", icon: <ShieldWarning size={20} className="text-red-500" />, label: <span className="text-red-500 font-bold">Master Wipe</span> },
    { to: "/forge/accounts", icon: <HardDrives size={20} />, label: "Forge Accounts" },
  ];

  const analyticsLinks = [
    { to: "/analytics", icon: <ChartLineUp size={20} />, label: "Analytics Dashboard", exact: true },
  ];

  const rdpLinks = [
    { to: "/rdp", icon: <SquaresFour size={20} />, label: "Dashboard", exact: true },
    { to: "/rdp/new", icon: <PlusCircle size={20} />, label: "New RDP Machine" },
    { to: "/rdp/machines", icon: <Desktop size={20} />, label: "My Machines" },
    { to: "/rdp/accounts", icon: <HardDrives size={20} />, label: "Azure Accounts" },
  ];

  const vultrLinks = [
    { to: "/vultr/new", icon: <PlusCircle size={20} />, label: "New RDP Machine" },
    { to: "/vultr/machines", icon: <Desktop size={20} />, label: "My Machines", exact: true },
    { to: "/vultr/accounts", icon: <HardDrives size={20} />, label: "Vultr Accounts" },
  ];

  const wpLinks = [
    { to: "/wordpress/new", icon: <PlusCircle size={20} />, label: "New Site" },
    { to: "/wordpress/sites", icon: <Browser size={20} />, label: "My Sites", exact: true },
    { to: "/wordpress/accounts", icon: <HardDrives size={20} />, label: "Builder Accounts" },
  ];

  const dcbotLinks = [
    { to: "/dcbot", icon: <Robot size={20} />, label: "My Bots", exact: true },
  ];

  const amplifyLinks = [
    { to: "/amplify", icon: <CloudArrowUp size={20} />, label: "Amplify Deployer", exact: true },
  ];

  const links = isAmplify ? amplifyLinks : (isDcbot ? dcbotLinks : (isWordpress ? wpLinks : (isVultr ? vultrLinks : (isRDP ? rdpLinks : (isAnalytics ? analyticsLinks : (isForge ? forgeLinks : (isNamecheap ? namecheapLinks : (isCocktail ? cocktailLinks : (isAzure ? azureLinks : (isHeroku ? herokuLinks : doLinks))))))))));
  const themeColor = isAmplify ? 'text-[#FF9900]' : (isDcbot ? 'text-[#229ED9]' : (isWordpress ? 'text-[#00A0D2]' : (isVultr ? 'text-[#007BFC]' : (isRDP ? 'text-[#14B8A6]' : (isAnalytics ? 'text-[#39FF14]' : (isForge ? 'text-[#FB503B]' : (isNamecheap ? 'text-[#00E5FF]' : (isCocktail ? 'text-[#FF0055]' : (isAzure ? 'text-[#0078D4]' : (isHeroku ? 'text-[#8b60ed]' : 'text-primary'))))))))));
  const themeBorder = isAmplify ? 'border-[#FF9900]' : (isDcbot ? 'border-[#229ED9]' : (isWordpress ? 'border-[#00A0D2]' : (isVultr ? 'border-[#007BFC]' : (isRDP ? 'border-[#14B8A6]' : (isAnalytics ? 'border-[#39FF14]' : (isForge ? 'border-[#FB503B]' : (isNamecheap ? 'border-[#00E5FF]' : (isCocktail ? 'border-[#FF0055]' : (isAzure ? 'border-[#0078D4]' : (isHeroku ? 'border-[#8b60ed]' : 'border-primary'))))))))));

  return (
    <div className="w-64 border-r border-white/10 bg-[#0A0B0E] flex flex-col h-screen shrink-0">
      <div className="p-6 border-b border-white/10 flex flex-col gap-6">
        
        {/* Global Branding */}
        <div className="flex items-center gap-3">
          <Logo className="w-10 h-10 text-white" themeColor={isAmplify ? '#FF9900' : (isDcbot ? '#229ED9' : (isWordpress ? '#00A0D2' : (isVultr ? '#007BFC' : (isRDP ? '#14B8A6' : (isAnalytics ? '#39FF14' : (isForge ? '#FB503B' : (isNamecheap ? '#00E5FF' : (isCocktail ? '#FF0055' : (isAzure ? '#0078D4' : (isHeroku ? '#8b60ed' : '#00E5FF'))))))))))} />
          <h1 className="text-2xl font-black font-sans tracking-tighter text-white uppercase">
            CDN<span className={themeColor}>DEPLOY</span>
          </h1>
        </div>

        <div className="flex flex-col gap-3">
          <button 
            onClick={() => navigate('/')}
            className="text-xs text-slate-500 hover:text-white uppercase tracking-widest flex items-center gap-1 font-bold transition-colors w-fit"
          >
            <ArrowLeft size={14} /> Switch Platform
          </button>

          {/* Platform Context Badge */}
          <div className="flex items-center gap-2 bg-white/5 p-2 border border-white/10">
            {isAmplify ? <CloudArrowUp size={16} className={themeColor} /> : (isDcbot ? <TelegramLogo size={16} className={themeColor} /> : (isWordpress ? <Browser size={16} className={themeColor} /> : (isVultr ? <Cloud size={16} className={themeColor} /> : (isRDP ? <Desktop size={16} className={themeColor} /> : (isAnalytics ? <ChartLineUp size={16} className={themeColor} /> : (isForge ? <Hammer size={16} className={themeColor} /> : (isNamecheap ? <Globe size={16} className={themeColor} /> : (isCocktail ? <Martini size={16} className={themeColor} /> : (isAzure ? <WindowsLogo size={16} className={themeColor} /> : (isHeroku ? <Cube size={16} className={themeColor} /> : <Cloud size={16} className={themeColor} />))))))))))}
            <h2 className={`text-[10px] font-bold font-sans uppercase tracking-widest ${themeColor}`}>
              {isAmplify ? 'AWS Amplify Workspace' : (isDcbot ? 'Telegram Bot Runner' : (isWordpress ? 'WordPress AI Builder' : (isVultr ? 'Vultr RDP Workspace' : (isRDP ? 'RDP Workspace' : (isAnalytics ? 'Analytics Workspace' : (isForge ? 'OnForge Workspace' : (isNamecheap ? 'Namecheap Workspace' : (isCocktail ? 'Cocktail Workspace' : (isAzure ? 'Azure Workspace' : (isHeroku ? 'Heroku Workspace' : 'Spaces Workspace'))))))))))}
            </h2>
          </div>
        </div>

      </div>
      <div className="flex-1 py-6 flex flex-col gap-2 px-4">
        {links.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            end={link.exact}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-2 text-sm transition-colors ${
                isActive ? `bg-white/10 ${themeColor} border-l-2 ${themeBorder} font-bold` : 'text-slate-400 hover:text-white hover:bg-white/5'
              }`
            }
          >
            {link.icon}
            {link.label}
          </NavLink>
        ))}
      </div>
      <div className="p-4 border-t border-white/10">
        <button
          onClick={logout}
          className="flex items-center gap-3 px-4 py-2 w-full text-sm text-red-400 hover:text-red-300 transition-colors"
        >
          <SignOut size={20} />
          Sign Out
        </button>
      </div>
    </div>
  );
};

export default Sidebar;